webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return CreateVideo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return GetVideoUploadParams; });
/* unused harmony export UploadVideo */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return PatchVideo; });
/* unused harmony export GetVideoById */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return GetVideoToPlay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return MarkVideoAsWatched; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return GetUsers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GetCurrentUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return Register; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return UpdateUserApproval; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return Login; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return PasswordReset; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return PasswordResetTwo; });
/* unused harmony export STATUS_UPLOADING */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return STATUS_UPLOADING_DONE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return STATUS_CANCELLED; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(24);


var CreateVideo = function CreateVideo(body) {
  return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.post('/api/v1/video', body).then(function (response) {
    return response.json();
  });
};

var GetVideoUploadParams = function GetVideoUploadParams(id) {
  return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.get('/api/v1/video/upload/' + id).then(function (response) {
    return response.json();
  });
};

var UploadVideo = function UploadVideo(url, video) {
  return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.put(url, video).then(function (response) {
    return response;
  });
};

var PatchVideo = function PatchVideo(id, body) {
  return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.patch('/api/v1/video/' + id, body);
};

var GetVideoById = function GetVideoById(id) {
  return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.get('/api/v1/video/' + id).then(function (response) {
    return response.json();
  });
};

var GetVideoToPlay = function GetVideoToPlay() {
  return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.get('/api/v1/videoPlay').then(function (response) {
    return response.json();
  });
};

var MarkVideoAsWatched = function MarkVideoAsWatched(id) {
  return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.get('/api/v1/videoPlay/watched/' + id).then(function (response) {
    return response;
  });
};

var GetUsers = function GetUsers() {
  return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.get('/api/v1/user').then(function (response) {
    return response.json();
  });
};

var GetCurrentUser = function GetCurrentUser() {
  return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.get('/api/v1/user/me').then(function (response) {
    return response.json();
  });
};

var Register = function Register(_ref) {
  var username = _ref.username,
      fullname = _ref.fullname,
      password = _ref.password,
      credit = _ref.credit;
  return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.post('/api/v1/user', {
    username: username,
    fullname: fullname,
    password: password,
    credit: credit
  }).then(function (response) {
    return response.json();
  });
};

var UpdateUserApproval = function UpdateUserApproval(_ref2) {
  var id = _ref2.id,
      approved = _ref2.approved;
  return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.patch('/api/v1/user/' + id, { approved: approved }).then(function (response) {
    return response;
  });
};

var Login = function Login(_ref3) {
  var username = _ref3.username,
      password = _ref3.password;
  return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.post('/login_check', {
    username: username,
    password: password
  }).then(function (response) {
    return response;
  });
};

var PasswordReset = function PasswordReset(_ref4) {
  var email = _ref4.email;
  return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.post('/api/v1/password_reset', { email: email });
};

var PasswordResetTwo = function PasswordResetTwo(_ref5) {
  var token = _ref5.token,
      password = _ref5.password;
  return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.post('/api/v1/password_reset2', { token: token, password: password });
};

var STATUS_UPLOADING = 'Uploading';
var STATUS_UPLOADING_DONE = 'Complete';
var STATUS_CANCELLED = 'Cancelled';

/***/ }),
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_index__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_api__ = __webpack_require__(10);





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);
var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/',
    component: __webpack_require__(211),
    name: 'view-home',
    meta: {
      authenticated: false,
      adminOnly: false
    }
  }, {
    path: '/video',
    component: __webpack_require__(218),
    name: 'view-video',
    meta: {
      authenticated: false,
      adminOnly: false
    }
  }, {
    path: '/upload_adder',
    component: __webpack_require__(216),
    name: 'view-upload',
    meta: {
      authenticated: true,
      adminOnly: false
    }
  }, {
    path: '/upload_success',
    component: __webpack_require__(215),
    name: 'view-upload-success',
    meta: {
      authenticated: true,
      adminOnly: false
    }
  }, {
    path: '/about',
    component: __webpack_require__(210),
    name: 'view-about',
    meta: {
      authenticated: false,
      adminOnly: false
    }
  }, {
    path: '/about_upload',
    component: __webpack_require__(209),
    name: 'view-about-upload',
    meta: {
      authenticated: false,
      adminOnly: false
    }
  }, {
    path: '/login',
    component: __webpack_require__(212),
    name: 'view-login',
    meta: {
      authenticated: false,
      adminOnly: false
    }
  }, {
    path: '/register',
    component: __webpack_require__(214),
    name: 'view-register',
    meta: {
      authenticated: false,
      adminOnly: false
    }
  }, {
    path: '/password-reset',
    component: __webpack_require__(213),
    name: 'view-password-reset',
    meta: {
      authenticated: false,
      adminOnly: false
    }
  }, {
    path: '/admin',
    component: __webpack_require__(217),
    name: 'view-user-approval',
    meta: {
      authenticated: true,
      adminOnly: true
    }
  }, {
    path: '*',
    component: __webpack_require__(208),
    name: '404',
    meta: {
      authenticated: false,
      adminOnly: false
    }
  }]
});

router.beforeEach(function (to, from, next) {
  if (to.meta.authenticated || to.meta.adminOnly) {
    if (__WEBPACK_IMPORTED_MODULE_2__store_index__["a" /* default */].getters.user) {
      if (to.meta.adminOnly) {
        return __WEBPACK_IMPORTED_MODULE_2__store_index__["a" /* default */].getters.isAdmin ? next() : next({ name: 'view-home' });
      }
      return next();
    }
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__services_api__["a" /* GetCurrentUser */])().then(function (res) {
      if (res.data) {
        __WEBPACK_IMPORTED_MODULE_2__store_index__["a" /* default */].dispatch('setUser', res.data);
        if (to.meta.adminOnly) {
          return __WEBPACK_IMPORTED_MODULE_2__store_index__["a" /* default */].getters.isAdmin ? next() : next({ name: 'view-home' });
        }
        return next();
      }
      return next({ name: 'view-login' });
    }).catch(function () {
      return next({ name: 'view-login' });
    });
  }
  return next();
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutation_types__ = __webpack_require__(85);





__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* default */].Store({
  state: {
    user: false,
    userIsAdmin: false
  },
  mutations: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["a" /* SET_USER */], function (state, user) {
    state.user = user;
    state.userIsAdmin = user.roles.indexOf('ROLE_ADMIN') > -1;
  }),
  actions: {
    setUser: function setUser(_ref, user) {
      var commit = _ref.commit;

      commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["a" /* SET_USER */], user);
    }
  },
  getters: {
    user: function user(state) {
      return state.user;
    },
    isAdmin: function isAdmin(state) {
      return state.userIsAdmin;
    }
  }
}));

/***/ }),
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(155)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(88),
  /* template */
  __webpack_require__(227),
  /* scopeId */
  "data-v-46f61abf",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(148)
__webpack_require__(149)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(86),
  /* template */
  __webpack_require__(221),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 82 */,
/* 83 */,
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_resource__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_analytics__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_analytics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_raven_js__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_raven_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_raven_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_raven_js_plugins_vue__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_raven_js_plugins_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_raven_js_plugins_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__App__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__router__ = __webpack_require__(47);










if (!Array.prototype.find) {
  Object.defineProperty(Array.prototype, 'find', {
    value: function value(predicate) {
      if (this == null) {
        throw new TypeError('"this" is null or not defined');
      }

      var o = Object(this);

      var len = o.length >>> 0;

      if (typeof predicate !== 'function') {
        throw new TypeError('predicate must be a function');
      }

      var thisArg = arguments[1];

      var k = 0;

      while (k < len) {
        var kValue = o[k];
        if (predicate.call(thisArg, kValue, k, o)) {
          return kValue;
        }

        k++;
      }

      return undefined;
    }
  });
}

if (true) {
  __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.config('https://1c093b1a88f6450ab4e16203ac441bb8@sentry.io/283125').addPlugin(__WEBPACK_IMPORTED_MODULE_5_raven_js_plugins_vue___default.a, __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]).install();
}

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vuelidate___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_analytics___default.a, {
  id: 'UA-127136600-1',
  router: __WEBPACK_IMPORTED_MODULE_7__router__["a" /* default */]
});

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_7__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_6__App___default.a }
});

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SET_BACKGROUND_IMAGE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_USER; });

var SET_BACKGROUND_IMAGE = 'SET_BACKGROUND_IMAGE';
var SET_USER = 'SET_USER';

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_AppHeader__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_AppHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_AppHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_AppFooter__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_AppFooter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_AppFooter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_index__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(47);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_2__store_index__["a" /* default */],
  components: {
    AppHeader: __WEBPACK_IMPORTED_MODULE_0__components_AppHeader___default.a,
    AppFooter: __WEBPACK_IMPORTED_MODULE_1__components_AppFooter___default.a
  }
});

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_sharer__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_sharer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_sharer__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app-footer',
  data: function data() {
    return {
      shareRoutes: ['view-home', 'view-video']
    };
  },

  directives: {
    sharer: __WEBPACK_IMPORTED_MODULE_0_vue_sharer___default.a
  },
  computed: {
    showShare: function showShare() {
      return this.shareRoutes.indexOf(this.$route.name) > -1;
    }
  }
});

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(29);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app-header',
  data: function data() {
    return {};
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['isAdmin']))
});

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_sharer__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_sharer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_sharer__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'credits',
  props: {
    creditData: {
      type: Array,
      required: false
    },
    displayCredits: {
      type: Boolean,
      required: true
    },
    reload: {
      required: true
    },
    hideCredits: {
      required: true
    },
    replayVideo: {
      required: true
    },
    typoCredit: {
      required: false
    }
  },
  data: function data() {
    return {
      bufferLarge: false
    };
  },

  directives: {
    sharer: __WEBPACK_IMPORTED_MODULE_1_vue_sharer___default.a
  },
  methods: {
    checkBuffer: function checkBuffer() {
      if (this.$refs.creditsBuffer) {
        this.bufferLarge = this.$refs.creditsBuffer.clientHeight >= 72;
      } else this.bufferLarge = false;
    },
    getLinksFromCredit: function getLinksFromCredit(credit) {
      var _this = this;

      if (!credit) return [];


      var base = credit;
      var credits = base.split(',').map(function (x) {
        return x.trim();
      });

      var targetSites = [{
        label: 'Twitter',
        target: 'twitter.com'
      }, {
        label: 'Facebook',
        target: 'facebook.com'
      }, {
        label: 'Instagram',
        target: 'instagram.com'
      }, {
        label: 'LinkedIn',
        target: 'linkedin.com'
      }];

      var processedCredits = [];

      targetSites.forEach(function (site) {
        var foundCredit = credits.filter(function (cred) {
          return cred.indexOf(site.target) > -1;
        })[0];
        if (foundCredit) {
          processedCredits.push({
            label: site.label,
            link: _this.checkProtocol(foundCredit)
          });
          credits.splice(credits.indexOf(foundCredit), 1);
        }
      });

      var parsedCredits = credits.map(function (cred) {
        var baseCredit = cred;
        return {
          label: _this.pruneProtocol(baseCredit),
          link: _this.checkProtocol(baseCredit)
        };
      });

      return [].concat(processedCredits, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(parsedCredits));
    },
    checkProtocol: function checkProtocol(str) {
      var url = str;

      var https = url.indexOf('https://') > -1;
      var http = url.indexOf('http://') > -1;

      if (https || http) return url;
      return 'http://' + url;
    },
    pruneProtocol: function pruneProtocol(str) {
      var url = str;

      return url.replace(/^https?\:\/\//i, '');
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$nextTick(function () {
      return _this2.checkBuffer();
    });
    window.addEventListener('resize', this.checkBuffer);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.checkBuffer);
  }
});

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_uppy_lib_core__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_uppy_lib_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_uppy_lib_core__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_uppy_lib_plugins_Dashboard__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_uppy_lib_plugins_Dashboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_uppy_lib_plugins_Dashboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_uppy_lib_plugins_AwsS3__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_uppy_lib_plugins_AwsS3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_uppy_lib_plugins_AwsS3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_api__ = __webpack_require__(10);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Upload',

  watch: {},
  data: function data() {
    return {
      uppy: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])(['user'])),
  mounted: function mounted() {
    this.initUppy();
  },

  methods: {
    initUppy: function initUppy() {
      var _this = this;

      this.uppy = __WEBPACK_IMPORTED_MODULE_3_uppy_lib_core___default()({
        autoProceed: false,

        meta: {
          creditName: this.user.fullname,
          creditLinks: this.user.credit
        },
        restrictions: {
          maxNumberOfFiles: 4
        },
        allowedFileTypes: ['video/*']
      });
      this.uppy.use(__WEBPACK_IMPORTED_MODULE_4_uppy_lib_plugins_Dashboard___default.a, {
        target: '#upload',
        inline: true,
        maxHeight: 300,
        width: 940,
        maxWidth: 940,
        locale: {
          strings: {
            dropPaste: 'Drag videos here or'
          }
        }
      });
      this.uppy.use(__WEBPACK_IMPORTED_MODULE_5_uppy_lib_plugins_AwsS3___default.a, {
        getUploadParameters: function getUploadParameters(file) {
          var promise = __WEBPACK_IMPORTED_MODULE_6__services_api__["h" /* CreateVideo */]({
            creditName: file.meta.creditName,
            creditLinks: file.meta.creditLinks,
            description: 'video description',
            title: 'video title'
          }).then(function (r) {
            file.meta.api = r.data;
            return __WEBPACK_IMPORTED_MODULE_6__services_api__["i" /* GetVideoUploadParams */](r.data.id);
          }).then(function (vidUrls) {
            return {
              method: 'PUT',
              url: vidUrls.url,
              fields: { file: file }
            };
          });

          return promise;
        }
      }).run();
      this.uppy.on('complete', function (result) {
        var successful = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(result.successful.map(function (f) {
          return __WEBPACK_IMPORTED_MODULE_6__services_api__["j" /* PatchVideo */](f.meta.api.id, {
            status: __WEBPACK_IMPORTED_MODULE_6__services_api__["k" /* STATUS_UPLOADING_DONE */]
          });
        }));

        var failed = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(result.failed.map(function (f) {
          return __WEBPACK_IMPORTED_MODULE_6__services_api__["j" /* PatchVideo */](f.meta.api.id, {
            status: __WEBPACK_IMPORTED_MODULE_6__services_api__["l" /* STATUS_CANCELLED */]
          });
        }));

        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all([successful, failed]).then(function (res) {
          if (result.successful) _this.$router.push({ name: 'view-upload-success' });
        });
      });
    }
  }
});

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ui-toggle',
  props: {
    toggle: {
      type: Boolean,
      required: true
    }
  }
});

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: '404'
});

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'about-upload'
});

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'about'
});

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_AppHeader__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_AppHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_AppHeader__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Home',
  methods: {
    goToVideo: function goToVideo() {
      this.$router.push({ name: 'view-video' });
    }
  },
  components: {
    AppHeader: __WEBPACK_IMPORTED_MODULE_0__components_AppHeader___default.a
  }
});

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_api__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(29);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'login',
  data: function data() {
    return {
      auth: {
        username: '',
        password: ''
      },
      authError: false,
      authMessage: false
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])(['setUser']), {
    submit: function submit() {
      var _this = this;

      if (this.auth.username && this.auth.password) {
        this.authError = false;
        this.authMessage = false;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__services_api__["g" /* Login */])(this.auth).then(function (res) {
          if (res.ok) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__services_api__["a" /* GetCurrentUser */])().then(function (data) {
              _this.setUser(data.data);
              _this.$router.push({ name: 'view-upload' });
            });
          }
        }).catch(function (err) {
          _this.authError = true;
          if (err.status === 401) _this.authMessage = 'Incorrect username or password';else _this.authMessage = err.body.message;
        });
      }
    }
  })
});

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_weak_map__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_weak_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_weak_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_api__ = __webpack_require__(10);






var touchMap = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_weak_map___default.a();

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'password-reset',
  data: function data() {
    return {
      auth: {
        email: '',
        password: '',
        passwordConfirm: ''
      },
      authError: false,
      authMessage: false,
      passwordResetSuccess: false
    };
  },

  validations: {
    auth: {
      password: { required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"], minLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["minLength"])(8) },
      passwordConfirm: { required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"], sameAsPassword: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["sameAs"])('password') }
    }
  },
  computed: {
    resetTitle: function resetTitle() {
      if (this.passwordResetSuccess) {
        return 'Your password has been updated, please use the link below to login';
      } else if (this.$route.query.token) {
        return 'Enter a new password';
      }
      return 'Requested a password change?';
    }
  },
  methods: {
    handleFieldInput: function handleFieldInput(field) {
      if (this.auth[field]) {
        this.$v.auth[field].$reset();
        if (touchMap.has(this.$v.auth[field])) {
          clearTimeout(touchMap.get(this.$v.auth[field]));
        }
        touchMap.set(this.$v.auth[field], setTimeout(this.$v.auth[field].$touch, 1000));
      }
    },
    submitEmail: function submitEmail() {
      var _this = this;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__services_api__["d" /* PasswordReset */])({ email: this.auth.email }).then(function (res) {
        if (res.ok) {
          _this.authMessage = 'Thanks, we\'ve sent you an email with a link to reset your password.';
        } else {
          _this.authMessage = 'Sorry, something went wrong';
        }
      }).catch(function () {
        _this.authMessage = 'Sorry, something went wrong';
      });
    },
    submitPassword: function submitPassword() {
      var _this2 = this;

      this.$v.auth.password.$touch();
      this.$v.auth.passwordConfirm.$touch();

      if (this.$v.auth.password.$error || this.$v.auth.passwordConfirm.$error) return;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__services_api__["e" /* PasswordResetTwo */])({ token: this.$route.query.token, password: this.auth.password }).then(function (res) {
        if (res.ok) {
          _this2.authMessage = 'Thanks, your password has been successfully updated.';
          _this2.passwordResetSuccess = true;
        } else {
          _this2.authMessage = 'Sorry, something went wrong';
        }
      }).catch(function () {
        _this2.authMessage = 'Sorry, something went wrong';
      });
    }
  }
});

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_weak_map__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_weak_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_weak_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_api__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__);






var touchMap = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_weak_map___default.a();

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'register',
  data: function data() {
    return {
      auth: {
        firstName: '',
        lastName: '',
        username: '',
        password: '',
        passwordConfirm: '',
        credit: ''
      },
      authError: false,
      authMessage: '',

      registrationSuccess: false
    };
  },

  validations: {
    auth: {
      username: { required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"], email: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["email"] },
      firstName: { required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"] },
      lastName: { required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"] },
      password: { required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"], minLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["minLength"])(8) },
      passwordConfirm: { required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"], sameAsPassword: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["sameAs"])('password') }
    }
  },
  computed: {
    authPayload: function authPayload() {
      return {
        fullname: this.auth.firstName + ' ' + this.auth.lastName,
        username: this.auth.username,
        password: this.auth.password,
        credit: this.auth.credit
      };
    },
    authFieldError: function authFieldError() {
      return this.$v.auth.username.$error || this.$v.auth.firstName.$error || this.$v.auth.lastName.$error || this.$v.auth.password.$error || this.$v.auth.passwordConfirm.$error;
    }
  },
  methods: {
    handleFieldInput: function handleFieldInput(field) {
      if (this.auth[field]) {
        this.$v.auth[field].$reset();
        if (touchMap.has(this.$v.auth[field])) {
          clearTimeout(touchMap.get(this.$v.auth[field]));
        }
        touchMap.set(this.$v.auth[field], setTimeout(this.$v.auth[field].$touch, 1000));
      }
    },
    submit: function submit() {
      var _this = this;

      this.authError = false;
      this.$v.auth.username.$touch();
      this.$v.auth.password.$touch();
      this.$v.auth.passwordConfirm.$touch();
      this.$v.auth.firstName.$touch();
      this.$v.auth.lastName.$touch();

      if (this.authFieldError) return;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__services_api__["f" /* Register */])(this.authPayload).then(function (res) {
        if (res) {
          _this.authMessage = 'Thank you for registering, once your account has been approved you will be able to log in.';
          _this.auth = {
            firstName: '',
            lastName: '',
            username: '',
            password: '',
            passwordConfirm: '',
            credit: ''
          };
          _this.$v.auth.username.$reset();
          _this.$v.auth.password.$reset();
          _this.$v.auth.passwordConfirm.$reset();
          _this.$v.auth.firstName.$reset();
          _this.$v.auth.lastName.$reset();

          _this.registrationSuccess = true;
        }
      }).catch(function (err) {
        _this.authError = true;
        _this.authMessage = 'Sorry, something went wrong: ' + err.data.Error;
      });
    }
  }
});

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'upload-success'
});

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Upload__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Upload__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'view-upload',
  data: function data() {
    return {
      creditName: null,
      creditLinks: null,
      contact: null
    };
  },

  components: {
    Upload: __WEBPACK_IMPORTED_MODULE_0__components_Upload___default.a
  }
});

/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ui_toggle__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ui_toggle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_ui_toggle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_api__ = __webpack_require__(10);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'user-approval',
  data: function data() {
    return {
      users: false,
      error: false
    };
  },

  methods: {
    getUsers: function getUsers() {
      var _this = this;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__services_api__["b" /* GetUsers */])().then(function (res) {
        _this.users = res.data;
      });
    },
    toggleUserApproval: function toggleUserApproval(id, newApproval) {
      var _this2 = this;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__services_api__["c" /* UpdateUserApproval */])({ id: id, approved: newApproval }).then(function (res) {
        if (res) _this2.getUsers();
      }).catch(function () {
        _this2.error = true;
      });
    }
  },
  components: {
    UiToggle: __WEBPACK_IMPORTED_MODULE_0__components_ui_toggle___default.a
  },
  mounted: function mounted() {
    var _this3 = this;

    this.$nextTick(function () {
      _this3.getUsers();
    });
  }
});

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_api__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Credits__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Credits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Credits__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'video-play',
  data: function data() {
    return {
      returnedVideo: false,
      viewRecorded: false,
      viewRecordSent: false,
      videoViewThreshold: 0.5,
      displayCredits: false
    };
  },

  computed: {
    videoLength: function videoLength() {
      if (this.returnedVideo) {
        return this.$refs.videoEl.duration;
      }
      return false;
    },
    creditData: function creditData() {
      if (this.returnedVideo) {
        return this.returnedVideo.credits.data;
      }
      return [];
    },
    typographyCredit: function typographyCredit() {
      if (this.returnedVideo && this.returnedVideo.typoCredit) {
        return this.returnedVideo.typoCredit;
      }
      return false;
    }
  },
  methods: {
    getVideoToPlay: function getVideoToPlay() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0__services_api__["m" /* GetVideoToPlay */]().then(function (res) {
        _this.returnedVideo = res.data;
      });
    },
    recordVideoView: function recordVideoView() {
      var _this2 = this;

      if (!this.viewRecorded) {
        __WEBPACK_IMPORTED_MODULE_0__services_api__["n" /* MarkVideoAsWatched */](this.returnedVideo.id).then(function (res) {
          if (res.ok) {
            _this2.viewRecorded = true;
          } else {
            _this2.viewRecordSent = false;
          }
        }).catch(function () {
          _this2.viewRecordSent = false;
        });
      }
    },
    reload: function reload() {
      var _this3 = this;

      this.displayCredits = false;
      this.returnedVideo = false;
      this.viewRecorded = false;
      this.viewRecordSent = false;
      this.$nextTick(function () {
        _this3.getVideoToPlay();
      });
    },
    checkVideoCompletion: function checkVideoCompletion() {
      if (this.$refs.videoEl) {
        var videoCurrentTime = this.$refs.videoEl.currentTime;
        if (!this.viewRecorded && !this.viewRecordSent && videoCurrentTime / this.videoLength > this.videoViewThreshold) {
          this.recordVideoView();
          this.viewRecordSent = true;
        }
      }
    },
    showCredits: function showCredits() {
      this.displayCredits = true;
      this.$refs.videoEl.pause();
    },
    hideCredits: function hideCredits() {
      this.displayCredits = false;
      if (!this.viewRecordSent) {
        this.$refs.videoEl.play();
      }
    },
    replayVideo: function replayVideo() {
      this.displayCredits = false;
      this.$refs.videoEl.currentTime = 0;
      this.$refs.videoEl.play();
    }
  },
  mounted: function mounted() {
    this.getVideoToPlay();
  },

  components: {
    Credits: __WEBPACK_IMPORTED_MODULE_1__components_Credits___default.a
  }
});

/***/ }),
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 147 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 148 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 149 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 150 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 151 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 152 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 153 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 154 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 155 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 156 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 157 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 158 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 159 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 160 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 161 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 162 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 163 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/BTAB_one_line.21d6d29.svg";

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/BTAB_svg.fa4d2ae.svg";

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/BTAB_svg_inverted.cf6dfe2.svg";

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/about_compiler_image.b8d51ed.svg";

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/about_upload_image.a09c45d.svg";

/***/ }),
/* 196 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjQgNCAxNiAxNiIgZmlsbD0ibm9uZSIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBjbGFzcz0iZmVhdGhlciBmZWF0aGVyLXgiPjxsaW5lIHgxPSIxOCIgeTE9IjYiIHgyPSI2IiB5Mj0iMTgiPjwvbGluZT48bGluZSB4MT0iNiIgeTE9IjYiIHgyPSIxOCIgeTI9IjE4Ij48L2xpbmU+PC9zdmc+"

/***/ }),
/* 197 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiPgogIDxwYXRoIGQ9Ik05NjcuNDggMGgtOTExQzI1LjI4LjAyLS4wMSAyNS4zMiAwIDU2LjUydjkxMWMuMDIgMzEuMiAyNS4zMiA1Ni40OCA1Ni41MiA1Ni40OEg1NDdWNjI4SDQxNFY0NzNoMTMzVjM1OWMwLTEzMi4yNiA4MC43Ny0yMDQuMjggMTk4Ljc2LTIwNC4yOCA1Ni41MSAwIDEwNS4wOCA0LjIxIDExOS4yNCA2LjA5VjI5OWgtODEuNjJjLTY0IDAtNzYuMzggMzAuNDktNzYuMzggNzUuMjNWNDczaDE1My40OWwtMjAgMTU1SDcwN3YzOTZoMjYwLjQ4YzMxLjIxLjAxIDU2LjUxLTI1LjI5IDU2LjUyLTU2LjVWNTYuNDhjLS4wMi0zMS4yLTI1LjMyLTU2LjQ5LTU2LjUyLTU2LjQ4eiIgZmlsbD0iI2ZmZiIvPgo8L3N2Zz4="

/***/ }),
/* 198 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiPgogIDxwYXRoIGQ9Ik05NjcuNDggMGgtOTExQzI1LjI4LjAyLS4wMSAyNS4zMiAwIDU2LjUydjkxMWMuMDIgMzEuMiAyNS4zMiA1Ni40OCA1Ni41MiA1Ni40OEg1NDdWNjI4SDQxNFY0NzNoMTMzVjM1OWMwLTEzMi4yNiA4MC43Ny0yMDQuMjggMTk4Ljc2LTIwNC4yOCA1Ni41MSAwIDEwNS4wOCA0LjIxIDExOS4yNCA2LjA5VjI5OWgtODEuNjJjLTY0IDAtNzYuMzggMzAuNDktNzYuMzggNzUuMjNWNDczaDE1My40OWwtMjAgMTU1SDcwN3YzOTZoMjYwLjQ4YzMxLjIxLjAxIDU2LjUxLTI1LjI5IDU2LjUyLTU2LjVWNTYuNDhjLS4wMi0zMS4yLTI1LjMyLTU2LjQ5LTU2LjUyLTU2LjQ4eiIgZmlsbD0iIzAwMCIvPgo8L3N2Zz4="

/***/ }),
/* 199 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNTUuMTYgMTQ0Ij4KICA8cGF0aCBkPSJNMTMzLjM0IDBIMTAuNjNDNC43NiAwIDAgNC42NSAwIDEwLjM4djEyMy4yM0MwIDEzOS4zNCA0Ljc2IDE0NCAxMC42MyAxNDRoMTIyLjcxYzUuODcgMCAxMC42Ni00LjY2IDEwLjY2LTEwLjM5VjEwLjM4QzE0NCA0LjY1IDEzOS4yMiAwIDEzMy4zNCAwek00Mi43MSAxMjIuNzFIMjEuMzVWNTMuOTloMjEuMzZ2NjguNzJ6TTMyLjAzIDQ0LjU5Yy02Ljg1IDAtMTIuMzktNS41NS0xMi4zOS0xMi4zOSAwLTYuODMgNS41NC0xMi4zOCAxMi4zOS0xMi4zOCA2LjgzIDAgMTIuMzggNS41NSAxMi4zOCAxMi4zOCAwIDYuODQtNS41NSAxMi4zOS0xMi4zOCAxMi4zOXptOTAuNjggNzguMTJoLTIxLjM0Vjg5LjI5YzAtNy45Ny0uMTUtMTguMjItMTEuMS0xOC4yMi0xMS4xMSAwLTEyLjgyIDguNjgtMTIuODIgMTcuNjV2MzRINTYuMVY1My45OWgyMC40OXY5LjM5aC4yOGMyLjg1LTUuNCA5LjgyLTExLjEgMjAuMjEtMTEuMSAyMS42MyAwIDI1LjYyIDE0LjIzIDI1LjYyIDMyLjc0djM3LjY5eiIgZmlsbD0iI2ZmZiIvPgo8L3N2Zz4="

/***/ }),
/* 200 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNTUuMTYgMTQ0Ij4KICA8cGF0aCBkPSJNMTMzLjM0IDBIMTAuNjNDNC43NiAwIDAgNC42NSAwIDEwLjM4djEyMy4yM0MwIDEzOS4zNCA0Ljc2IDE0NCAxMC42MyAxNDRoMTIyLjcxYzUuODcgMCAxMC42Ni00LjY2IDEwLjY2LTEwLjM5VjEwLjM4QzE0NCA0LjY1IDEzOS4yMiAwIDEzMy4zNCAwek00Mi43MSAxMjIuNzFIMjEuMzVWNTMuOTloMjEuMzZ2NjguNzJ6TTMyLjAzIDQ0LjU5Yy02Ljg1IDAtMTIuMzktNS41NS0xMi4zOS0xMi4zOSAwLTYuODMgNS41NC0xMi4zOCAxMi4zOS0xMi4zOCA2LjgzIDAgMTIuMzggNS41NSAxMi4zOCAxMi4zOCAwIDYuODQtNS41NSAxMi4zOS0xMi4zOCAxMi4zOXptOTAuNjggNzguMTJoLTIxLjM0Vjg5LjI5YzAtNy45Ny0uMTUtMTguMjItMTEuMS0xOC4yMi0xMS4xMSAwLTEyLjgyIDguNjgtMTIuODIgMTcuNjV2MzRINTYuMVY1My45OWgyMC40OXY5LjM5aC4yOGMyLjg1LTUuNCA5LjgyLTExLjEgMjAuMjEtMTEuMSAyMS42MyAwIDI1LjYyIDE0LjIzIDI1LjYyIDMyLjc0djM3LjY5eiIgZmlsbD0iIzAwMCIvPgo8L3N2Zz4="

/***/ }),
/* 201 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0MDAgNDAwIj4KICA8cGF0aCBkPSJNMTI1Ljc5IDM2NS4wMmMxNTAuOTQgMCAyMzMuNS0xMjUuMDYgMjMzLjUtMjMzLjUgMC0zLjU1IDAtNy4wOS0uMjQtMTAuNjEgMTYuMDYtMTEuNjIgMjkuOTMtMjYgNDAuOTQtNDIuNDhhMTYzLjY1MyAxNjMuNjUzIDAgMCAxLTQ3LjE0IDEyLjkxIDgyLjQgODIuNCAwIDAgMCAzNi4wOC00NS4zOSAxNjQuMzM1IDE2NC4zMzUgMCAwIDEtNTIuMTEgMTkuOTJjLTMxLjA4LTMzLjA1LTgzLjA3LTM0LjY0LTExNi4xMS0zLjU2LTIxLjMxIDIwLjA0LTMwLjM2IDQ5LjkxLTIzLjc0IDc4LjQxQTIzMy4wMDggMjMzLjAwOCAwIDAgMSAyNy44MyA1NC45OGMtMjEuNzggMzcuNS0xMC42NiA4NS40NyAyNS40MSAxMDkuNTVhODEuNTEyIDgxLjUxMiAwIDAgMS0zNy4yNS0xMC4yN3YxLjA0Yy4wMSAzOS4wNyAyNy41NSA3Mi43MSA2NS44NCA4MC40NWE4MS44NjMgODEuODYzIDAgMCAxLTM3LjA2IDEuNDFjMTAuNzUgMzMuNDMgNDEuNTYgNTYuMzMgNzYuNjcgNTYuOTlhMTY0LjY1IDE2NC42NSAwIDAgMS0xMDEuOTIgMzUuMmMtNi41My0uMDEtMTMuMDUtLjQxLTE5LjU0LTEuMThhMjMyLjM3IDIzMi4zNyAwIDAgMCAxMjUuNzkgMzYuOCIgZmlsbD0iI2ZmZiIvPgo8L3N2Zz4="

/***/ }),
/* 202 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0MDAgNDAwIj4KICA8cGF0aCBkPSJNMTI1Ljc5IDM2NS4wMmMxNTAuOTQgMCAyMzMuNS0xMjUuMDYgMjMzLjUtMjMzLjUgMC0zLjU1IDAtNy4wOS0uMjQtMTAuNjEgMTYuMDYtMTEuNjIgMjkuOTMtMjYgNDAuOTQtNDIuNDhhMTYzLjY1MyAxNjMuNjUzIDAgMCAxLTQ3LjE0IDEyLjkxIDgyLjQgODIuNCAwIDAgMCAzNi4wOC00NS4zOSAxNjQuMzM1IDE2NC4zMzUgMCAwIDEtNTIuMTEgMTkuOTJjLTMxLjA4LTMzLjA1LTgzLjA3LTM0LjY0LTExNi4xMS0zLjU2LTIxLjMxIDIwLjA0LTMwLjM2IDQ5LjkxLTIzLjc0IDc4LjQxQTIzMy4wMDggMjMzLjAwOCAwIDAgMSAyNy44MyA1NC45OGMtMjEuNzggMzcuNS0xMC42NiA4NS40NyAyNS40MSAxMDkuNTVhODEuNTEyIDgxLjUxMiAwIDAgMS0zNy4yNS0xMC4yN3YxLjA0Yy4wMSAzOS4wNyAyNy41NSA3Mi43MSA2NS44NCA4MC40NWE4MS44NjMgODEuODYzIDAgMCAxLTM3LjA2IDEuNDFjMTAuNzUgMzMuNDMgNDEuNTYgNTYuMzMgNzYuNjcgNTYuOTlhMTY0LjY1IDE2NC42NSAwIDAgMS0xMDEuOTIgMzUuMmMtNi41My0uMDEtMTMuMDUtLjQxLTE5LjU0LTEuMThhMjMyLjM3IDIzMi4zNyAwIDAgMCAxMjUuNzkgMzYuOCIgZmlsbD0iIzAwMCIvPgo8L3N2Zz4="

/***/ }),
/* 203 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(150)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(87),
  /* template */
  __webpack_require__(222),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(151)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(89),
  /* template */
  __webpack_require__(223),
  /* scopeId */
  "data-v-2635a0ea",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(162)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(90),
  /* template */
  __webpack_require__(234),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(159)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(91),
  /* template */
  __webpack_require__(231),
  /* scopeId */
  "data-v-6c5d5ffe",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(163)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(92),
  /* template */
  __webpack_require__(235),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(158)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(93),
  /* template */
  __webpack_require__(230),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(147)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(94),
  /* template */
  __webpack_require__(220),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(160)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(95),
  /* template */
  __webpack_require__(232),
  /* scopeId */
  "data-v-a947392c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(154)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(96),
  /* template */
  __webpack_require__(226),
  /* scopeId */
  "data-v-43d61f24",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(157)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(97),
  /* template */
  __webpack_require__(229),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(161)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(98),
  /* template */
  __webpack_require__(233),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(152)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(99),
  /* template */
  __webpack_require__(224),
  /* scopeId */
  "data-v-335f2f02",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(153)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(100),
  /* template */
  __webpack_require__(225),
  /* scopeId */
  "data-v-40d70acc",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(156)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(101),
  /* template */
  __webpack_require__(228),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(146)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(102),
  /* template */
  __webpack_require__(219),
  /* scopeId */
  "data-v-0a8f23de",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "video-play"
  }, [_c('section', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "section__wrapper video-play__wrapper"
  }, [_c('div', {
    staticClass: "video-play__wrapper--inner"
  }, [(_vm.returnedVideo) ? _c('video', {
    ref: "videoEl",
    staticClass: "video-play__video",
    attrs: {
      "id": ("video-" + (_vm.returnedVideo.id)),
      "controls": "true",
      "preload": "auto"
    },
    on: {
      "ended": _vm.showCredits,
      "timeupdate": _vm.checkVideoCompletion
    }
  }, [_c('source', {
    attrs: {
      "src": _vm.returnedVideo.url,
      "type": "video/mp4"
    }
  })]) : _vm._e()])])]), _vm._v(" "), _c('section', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "section__wrapper mt-4"
  }, [_c('div', {
    staticClass: "video-play__options-bar"
  }, [_c('div', {
    staticClass: "video-play__options--left"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'view-home'
      }
    }
  }, [_c('img', {
    staticClass: "video-play__home-link",
    attrs: {
      "src": __webpack_require__(191),
      "alt": "Britain Take A Bow"
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "video-play__options--right"
  }, [_c('button', {
    staticClass: "button video-play__button",
    on: {
      "click": _vm.reload
    }
  }, [_vm._v("Load a new version")]), _vm._v(" "), _c('p', {
    staticClass: "video-play__link video-play__credits-link",
    on: {
      "click": _vm.showCredits
    }
  }, [_vm._v("Credits")])])])])]), _vm._v(" "), _c('credits', {
    attrs: {
      "displayCredits": _vm.displayCredits,
      "creditData": _vm.creditData,
      "reload": _vm.reload,
      "hideCredits": _vm.hideCredits,
      "replayVideo": _vm.replayVideo,
      "typoCredit": _vm.typographyCredit
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 220 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app__content about"
  }, [_c('section', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "section__wrapper"
  }, [_c('div', {
    staticClass: "section__content section__copy"
  }, [_c('h2', [_vm._v("About")]), _vm._v(" "), _c('p', [_vm._v("Britain, Take A Bow is a multi-participatory, generative artwork that reflects on the idea of Britishness and nationalism as we hurtle towards exiting the European Union.")]), _vm._v(" "), _c('p', [_vm._v("We’re living through a time of political uncertainty. Brexit has divided the nation. The far right is resurgent, our public services are on their knees, people are disconnected and atomised. Politicians lie and the mainstream media is pushing an anachronistic, sentimental vision of a mis-remembered Britain.")]), _vm._v(" "), _c('p', [_vm._v("Britain, Take A Bow enables filmmakers to upload filmed vignettes of daily life (sad, uplifting, mundane, terrifying) in the UK to a database, which are then processed, compiled and cut to an ever-changing version of the national anthem to create an always evolving artwork.")]), _vm._v(" "), _c('p', [_vm._v("No two views will ever be the same.")]), _vm._v(" "), _c('p', {
    staticClass: "about__register-link"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'view-home'
      }
    }
  }, [_vm._v("Back")])], 1)])])])])
},staticRenderFns: []}

/***/ }),
/* 221 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "app__body",
    class: _vm.$route.name,
    attrs: {
      "id": "app"
    }
  }, [(this.$route.name !== 'view-video') ? _c('app-header') : _vm._e(), _vm._v(" "), _c('keep-alive', {
    attrs: {
      "include": 'register'
    }
  }, [_c('router-view')], 1), _vm._v(" "), _c('app-footer')], 1)
},staticRenderFns: []}

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section footer"
  }, [_c('div', {
    staticClass: "section__wrapper"
  }, [_c('div', {
    staticClass: "section__content footer__content"
  }, [_vm._m(0), _vm._v(" "), (_vm.showShare) ? _c('div', {
    staticClass: "footer__content-block mb-2"
  }, [_c('span', {
    staticClass: "footer__label mr-3"
  }, [_vm._v("Share:")]), _vm._v(" "), _c('img', {
    directives: [{
      name: "sharer",
      rawName: "v-sharer"
    }],
    staticClass: "footer__social-icon mr-3",
    attrs: {
      "data-sharer": "twitter",
      "data-title": "Britain, Take A Bow!",
      "data-url": "https://britaintakeabow.org",
      "src": __webpack_require__(201),
      "alt": "Twitter icon"
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "sharer",
      rawName: "v-sharer"
    }],
    staticClass: "footer__social-icon mr-3",
    attrs: {
      "data-sharer": "facebook",
      "data-url": "https://britaintakeabow.org",
      "src": __webpack_require__(197),
      "alt": "Facebook icon"
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "sharer",
      rawName: "v-sharer"
    }],
    staticClass: "footer__social-icon mr-3",
    attrs: {
      "data-sharer": "linkedin",
      "data-url": "https://britaintakeabow.org",
      "src": __webpack_require__(199),
      "alt": "LinkedIn icon"
    }
  })]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer__content-block mb-2"
  }, [_c('a', {
    staticClass: "footer__label mr-3",
    attrs: {
      "href": "mailto:btab@tuimedia.com?subject=Britain Take A Bow"
    }
  }, [_vm._v("Contact")])])
}]}

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "overlayFade"
    }
  }, [(_vm.displayCredits) ? _c('div', {
    staticClass: "credits__wrapper"
  }, [_c('section', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "section__wrapper"
  }, [_c('div', {
    staticClass: "section__content"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'view-home'
      }
    }
  }, [_c('img', {
    staticClass: "credits__hero",
    attrs: {
      "src": __webpack_require__(193),
      "alt": "Britain Take A Bow"
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "credits__close-icon-wrapper",
    on: {
      "click": _vm.hideCredits
    }
  }, [_c('img', {
    staticClass: "credits__close-icon",
    attrs: {
      "src": __webpack_require__(196),
      "alt": "Close credits"
    }
  })])])]), _vm._v(" "), _c('section', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "section__wrapper"
  }, [_c('div', {
    staticClass: "section__content"
  }, [_c('div', {
    staticClass: "credits__top-section"
  }, [_c('button', {
    staticClass: "mb-2 mr-2 button inverted",
    on: {
      "click": _vm.replayVideo
    }
  }, [_vm._v("Play again")]), _vm._v(" "), _c('button', {
    staticClass: "mb-2 mr-3 button",
    on: {
      "click": _vm.reload
    }
  }, [_vm._v("Load a new version")]), _vm._v(" "), _c('div', {
    staticClass: "mb-2 credits__share-links"
  }, [_c('span', {
    staticClass: "credits__share-label mr-3"
  }, [_vm._v("Share:")]), _vm._v(" "), _c('img', {
    directives: [{
      name: "sharer",
      rawName: "v-sharer"
    }],
    staticClass: "footer__social-icon mr-3",
    attrs: {
      "data-sharer": "twitter",
      "data-title": "Britain, Take A Bow!",
      "data-url": "https://britaintakeabow.org",
      "src": __webpack_require__(202),
      "alt": "Twitter icon"
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "sharer",
      rawName: "v-sharer"
    }],
    staticClass: "footer__social-icon mr-3",
    attrs: {
      "data-sharer": "facebook",
      "data-url": "https://britaintakeabow.org",
      "src": __webpack_require__(198),
      "alt": "Facebook icon"
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "sharer",
      rawName: "v-sharer"
    }],
    staticClass: "footer__social-icon mr-3",
    attrs: {
      "data-sharer": "linkedin",
      "data-url": "https://britaintakeabow.org",
      "src": __webpack_require__(200),
      "alt": "LinkedIn icon"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "credits__grid"
  }, [_c('div', {
    staticClass: "credits__grid-item credits__grid-item--has-heading"
  }, [_c('p', {
    staticClass: "credits__grid-item-heading"
  }, [_vm._v("By:")]), _vm._v(" "), _c('p', [_vm._v("Graeme Crowley")])]), _vm._v(" "), _c('div', {
    staticClass: "credits__grid-item credits__grid-item--has-heading"
  }, [_c('p', {
    staticClass: "credits__grid-item-heading"
  }, [_vm._v("Special thanks to:")]), _vm._v(" "), _c('p', [_vm._v("Audio production by Paul Crowley")]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "credits__link",
    attrs: {
      "href": "https://www.linkedin.com/in/jackhardiker?originalSubdomain=uk"
    }
  }, [_vm._v("Jack Hardiker")]), _vm._v(" and "), _c('a', {
    staticClass: "credits__link",
    attrs: {
      "href": "https://vimeo.com/259905941"
    }
  }, [_vm._v("Midnight Oil")])]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "credits__link",
    attrs: {
      "href": "http://simonellisfilms.com"
    }
  }, [_vm._v("Simon Ellis")])])]), _vm._v(" "), _c('div', {
    staticClass: "credits__grid-item credits__grid-item--has-heading"
  }, [_c('p', {
    staticClass: "credits__grid-item-heading"
  }), _vm._v(" "), _c('p', [_vm._v("Richard Baker")]), _vm._v(" "), _c('p', [_vm._v("Horace Keating")]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "credits__link",
    attrs: {
      "href": "https://www.tuimedia.com"
    }
  }, [_c('img', {
    staticClass: "credits__link-img",
    attrs: {
      "src": __webpack_require__(203),
      "alt": "Tui Media"
    }
  })])])]), _vm._v(" "), (_vm.typoCredit) ? _c('div', {
    staticClass: "credits__grid-item credits__grid-item--has-heading"
  }, [_c('p', {
    staticClass: "credits__grid-item-heading"
  }, [_vm._v("Typography:")]), _vm._v(" "), _c('p', {
    staticClass: "credits__grid-item-name"
  }, [_vm._v(_vm._s(_vm.typoCredit.name))]), _vm._v(" "), _vm._l((_vm.getLinksFromCredit(_vm.typoCredit.credit)), function(link, index) {
    return _c('a', {
      key: ("credit-" + (_vm.typoCredit.fullName) + "-" + index),
      staticClass: "credits__grid-item-credit credits__link",
      attrs: {
        "href": link.link,
        "target": "_blank"
      }
    }, [_vm._v("\n                " + _vm._s(link.label) + "\n              ")])
  })], 2) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "credits__grid"
  }, [_c('div', {
    staticClass: "credits__grid-item"
  }, [_c('p', [_c('a', {
    staticClass: "credits__link",
    attrs: {
      "href": "http://www.royalspabrass.com"
    }
  }, [_vm._v("Hugh Rashleigh and Royal Spa Brass")])]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "credits__link",
    attrs: {
      "href": "https://www.etsy.com/uk/shop/mustardandbloodart?ref=l2-shopheader-name"
    }
  }, [_vm._v("Jonny Nicholds")]), _vm._v(", "), _c('a', {
    staticClass: "credits__link",
    attrs: {
      "href": "https://en-gb.facebook.com/lucyannesalemusic/"
    }
  }, [_vm._v("Lucy Anne Sale")]), _vm._v(", "), _c('a', {
    staticClass: "credits__link",
    attrs: {
      "href": "http://wesfinch.co.uk/"
    }
  }, [_vm._v("Wes Finch")]), _vm._v(" and the Mustard & Blood Orchestra")])]), _vm._v(" "), _c('div', {
    staticClass: "credits__grid-item"
  }, [_c('p', {
    ref: "creditsBuffer",
    staticClass: "credits__item--is-buffer"
  }, [_c('a', {
    staticClass: "credits__link",
    attrs: {
      "href": "https://www.instagram.com/lizbuffcrowley/"
    }
  }, [_vm._v("Liz Crowley")]), _vm._v(" for organising and "), _c('a', {
    staticClass: "credits__link",
    attrs: {
      "href": "https://uk.linkedin.com/in/drew-coleman-7aa38147"
    }
  }, [_vm._v("Drew Coleman")]), _vm._v(" for recording:")]), _vm._v(" "), _c('p', [_vm._v("Adrian Tomaszewski")]), _vm._v(" "), _c('p', [_vm._v("Alexandru Kraus")]), _vm._v(" "), _c('p', [_vm._v("Barthe Makosso")]), _vm._v(" "), _c('p', [_vm._v("Brenna McCann")])]), _vm._v(" "), _c('div', {
    staticClass: "credits__grid-item"
  }, [_c('p', {
    staticClass: "credits__item--has-buffer",
    class: {
      'credits__item--has-buffer-large': _vm.bufferLarge
    }
  }, [_vm._v("Elena Fulea")]), _vm._v(" "), _c('p', [_vm._v("Elina Baltina")]), _vm._v(" "), _c('p', [_vm._v("Greta Lazdovska")]), _vm._v(" "), _c('p', [_vm._v("Jeffy Jigy")])]), _vm._v(" "), _c('div', {
    staticClass: "credits__grid-item"
  }, [_c('p', {
    staticClass: "credits__item--has-buffer credits__item--drop-buffer",
    class: {
      'credits__item--has-buffer-large': _vm.bufferLarge
    }
  }, [_vm._v("Mateuz Cetnarski")]), _vm._v(" "), _c('p', [_vm._v("Musa Nasibu")]), _vm._v(" "), _c('p', [_vm._v("Nimeshika Rathnapriyalage")]), _vm._v(" "), _c('p', [_vm._v("Vilario Fernandez")])])]), _vm._v(" "), (_vm.creditData.length) ? _c('p', [_vm._v("This viewing featured the work of:")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "credits__grid"
  }, _vm._l((_vm.creditData), function(credit, index) {
    return _c('div', {
      key: ("credit-" + index),
      staticClass: "credits__grid-item"
    }, [_c('p', {
      staticClass: "credits__grid-item-name"
    }, [_vm._v(_vm._s(credit.fullname))]), _vm._v(" "), _vm._l((_vm.getLinksFromCredit(credit.credit)), function(link, index) {
      return _c('a', {
        key: ("credit-" + (credit.fullName) + "-" + index),
        staticClass: "credits__grid-item-credit credits__link",
        attrs: {
          "href": link.link,
          "target": "_blank"
        }
      }, [_vm._v("\n                " + _vm._s(link.label) + "\n              ")])
    })], 2)
  }))])])])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 224 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app__content"
  }, [_c('section', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "section__wrapper"
  }, [_c('div', {
    staticClass: "section__content section__copy"
  }, [_c('h2', [_vm._v("Success")]), _vm._v(" "), _c('p', [_vm._v("Thank you for contributing to Britain, Take A Bow.")]), _vm._v(" "), _c('p', [_vm._v("Your clips are now being processed and added to the database, ready to be streamed - this may take a few minutes. Please be aware that because of the random nature of the piece your clips may not always make it into the edit.")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'view-video'
      }
    }
  }, [_c('button', {
    staticClass: "button"
  }, [_vm._v("Watch a new version")])])], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 225 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app__content"
  }, [_vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "section__wrapper"
  }, [_c('div', {
    staticClass: "section__content section__copy"
  }, [_c('div', {
    staticClass: "mb-4"
  }, [_c('upload', {
    attrs: {
      "creditName": _vm.creditName,
      "creditLinks": _vm.creditLinks,
      "contact": _vm.contact
    }
  })], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "section__wrapper"
  }, [_c('div', {
    staticClass: "section__content section__copy"
  }, [_c('h2', [_vm._v("Uploader")]), _vm._v(" "), _c('p', [_vm._v("We will apply this "), _c('a', {
    attrs: {
      "href": "https://creativecommons.org/licenses/by-nc-nd/4.0/"
    }
  }, [_vm._v("Creative Commons")]), _vm._v(" licence to your uploaded videos.")]), _vm._v(" "), _c('p', [_vm._v("It states that we will use the video you upload only for this project, that we won't use it commercially, and we'll credit you every time it is shown.")])])])])
}]}

/***/ }),
/* 226 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app__content section"
  }, [_c('div', {
    staticClass: "section__wrapper"
  }, [_c('div', {
    staticClass: "section__content"
  }, [_c('h2', {}, [_vm._v("Uploader")]), _vm._v(" "), _c('form', {
    staticClass: "form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submit()
      }
    }
  }, [_c('div', {
    staticClass: "form__group"
  }, [_c('p', [_vm._v("Please log in")]), _vm._v(" "), _c('div', {
    staticClass: "form__input-group form__input-group--full form__input-group--wrap"
  }, [_c('label', {
    staticClass: "form__label--hidden",
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.auth.username),
      expression: "auth.username"
    }],
    staticClass: "form__input",
    class: {
      'form__input--error': _vm.authError
    },
    attrs: {
      "name": "email",
      "type": "email",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.auth.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.auth.username = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form__label--hidden",
    attrs: {
      "for": "password"
    }
  }, [_vm._v("Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.auth.password),
      expression: "auth.password"
    }],
    staticClass: "form__input",
    class: {
      'form__input--error': _vm.authError
    },
    attrs: {
      "name": "password",
      "type": "password",
      "placeholder": "Password"
    },
    domProps: {
      "value": (_vm.auth.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.auth.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "button form__submit",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n                Log in\n            ")]), _vm._v(" "), _c('router-link', {
    staticClass: "form__link",
    attrs: {
      "to": 'password-reset'
    }
  }, [_vm._v("Forgotten password?")])], 1), _vm._v(" "), (_vm.authMessage) ? _c('p', {
    staticClass: "form__help--error mr-2"
  }, [_vm._v(_vm._s(_vm.authMessage))]) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "form__link",
    attrs: {
      "to": 'register'
    }
  }, [_vm._v("Register")])], 1)])])])])
},staticRenderFns: []}

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section hero"
  }, [_c('div', {
    staticClass: "section__wrapper"
  }, [_c('div', {
    staticClass: "section__content"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'view-home'
      }
    }
  }, [_c('img', {
    staticClass: "hero__heading",
    attrs: {
      "src": __webpack_require__(192),
      "alt": "Britain Take A Bow"
    }
  })]), _vm._v(" "), (_vm.isAdmin) ? _c('div', {
    staticClass: "hero__admin-nav"
  }, [_c('p', [_vm._v("Admin user")]), _vm._v(" "), _c('p', [_c('router-link', {
    attrs: {
      "to": {
        name: 'view-user-approval'
      }
    }
  }, [_vm._v("Approve users")])], 1), _vm._v(" "), _c('p', [_c('router-link', {
    attrs: {
      "to": {
        name: 'view-upload'
      }
    }
  }, [_vm._v("Upload")])], 1), _vm._v(" "), _c('p', [_c('router-link', {
    attrs: {
      "to": {
        name: 'view-home'
      }
    }
  }, [_vm._v("Home")])], 1)]) : _vm._e()], 1)])])
},staticRenderFns: []}

/***/ }),
/* 228 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app__content section"
  }, [_c('div', {
    staticClass: "section__wrapper"
  }, [_c('div', {
    staticClass: "section__content"
  }, [_c('h2', {}, [_vm._v("User approval")]), _vm._v(" "), _c('table', {
    staticClass: "admin__table"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.users), function(user) {
    return _c('tr', {
      key: user.id,
      staticClass: "admin__table-row"
    }, [_c('td', {
      staticClass: "admin__table-cell"
    }, [_vm._v("\n            " + _vm._s(user.fullname) + "\n          ")]), _vm._v(" "), _c('td', {
      staticClass: "admin__table-cell"
    }, [_vm._v("\n            " + _vm._s(user.username) + "\n          ")]), _vm._v(" "), _c('td', {
      staticClass: "admin__table-cell"
    }, [_vm._v("\n            " + _vm._s(user.roles.indexOf('ROLE_ADMIN') > -1) + "\n          ")]), _vm._v(" "), _c('td', {
      staticClass: "admin__table-cell"
    }, [_c('ui-toggle', {
      attrs: {
        "toggle": user.approved
      },
      nativeOn: {
        "click": function($event) {
          _vm.toggleUserApproval(user.id, !user.approved)
        }
      }
    })], 1)])
  })], 2)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "admin__table-row admin__table-row--heading"
  }, [_c('th', {
    staticClass: "admin__table-heading admin__table-cell"
  }, [_vm._v("\n            Full name\n          ")]), _vm._v(" "), _c('th', {
    staticClass: "admin__table-heading admin__table-cell"
  }, [_vm._v("\n            Username\n          ")]), _vm._v(" "), _c('th', {
    staticClass: "admin__table-heading admin__table-cell"
  }, [_vm._v("\n            Admin\n          ")]), _vm._v(" "), _c('th', {
    staticClass: "admin__table-heading admin__table-cell"
  }, [_vm._v("\n            Approved\n          ")])])
}]}

/***/ }),
/* 229 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app__content section"
  }, [_c('div', {
    staticClass: "section__wrapper"
  }, [_c('div', {
    staticClass: "section__content"
  }, [_c('h2', {}, [_vm._v(_vm._s(_vm.resetTitle))]), _vm._v(" "), (_vm.$route.query.token && !_vm.passwordResetSuccess) ? _c('form', {
    staticClass: "form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submitPassword()
      }
    }
  }, [_c('div', {
    staticClass: "form__group"
  }, [_c('p', [_vm._v("Choose a new password")]), _vm._v(" "), _c('div', {
    staticClass: "form__input-group form__input-group--full form__input-group--wrap"
  }, [_c('label', {
    staticClass: "form__label--hidden",
    attrs: {
      "for": "password"
    }
  }, [_vm._v("New password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.auth.password),
      expression: "auth.password"
    }],
    staticClass: "form__input",
    class: {
      'form__input--error': _vm.$v.auth.password.$error
    },
    attrs: {
      "name": "password",
      "type": "password",
      "placeholder": "Password"
    },
    domProps: {
      "value": (_vm.auth.password)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.auth.password = $event.target.value
      }, function($event) {
        _vm.handleFieldInput('password')
      }]
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form__label--hidden",
    attrs: {
      "for": "passwordConfirm"
    }
  }, [_vm._v("Confirm password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.auth.passwordConfirm),
      expression: "auth.passwordConfirm"
    }],
    staticClass: "form__input",
    class: {
      'form__input--error': _vm.$v.auth.password.$error
    },
    attrs: {
      "name": "passwordConfirm",
      "type": "password",
      "placeholder": "Confirm password"
    },
    domProps: {
      "value": (_vm.auth.passwordConfirm)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.auth.passwordConfirm = $event.target.value
      }, function($event) {
        _vm.handleFieldInput('passwordConfirm')
      }]
    }
  }), _vm._v(" "), (_vm.$v.auth.password.$error || _vm.$v.auth.passwordConfirm.$error) ? _c('span', {
    staticClass: "form__help form__help--error"
  }, [_vm._v("\n              Your password must be 8 or more characters. Password confirmation must match password.\n            ")]) : _vm._e()]), _vm._v(" "), _c('button', {
    staticClass: "button form__submit",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n                Submit\n            ")]), _vm._v(" "), (_vm.authMessage) ? _c('p', {
    staticClass: "form__link mr-2"
  }, [_vm._v(_vm._s(_vm.authMessage))]) : _vm._e()])]) : (!_vm.passwordResetSuccess) ? _c('form', {
    staticClass: "form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submitEmail()
      }
    }
  }, [_c('div', {
    staticClass: "form__group"
  }, [_c('p', [_vm._v("Enter your email and we'll send you a link to reset your password")]), _vm._v(" "), _c('div', {
    staticClass: "form__input-group form__input-group--full form__input-group--wrap"
  }, [_c('label', {
    staticClass: "form__label--hidden",
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.auth.email),
      expression: "auth.email"
    }],
    staticClass: "form__input",
    class: {
      'form__input--error': _vm.authError
    },
    attrs: {
      "name": "email",
      "type": "email",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.auth.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.auth.email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "button form__submit",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n                Send\n            ")]), _vm._v(" "), (_vm.authMessage) ? _c('p', {
    staticClass: "form__link mr-2"
  }, [_vm._v(_vm._s(_vm.authMessage))]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "form__link mr-2",
    attrs: {
      "to": {
        name: 'view-login'
      }
    }
  }, [_vm._v("Login")]), _vm._v(" "), _c('router-link', {
    staticClass: "form__link",
    attrs: {
      "to": {
        name: 'view-register'
      }
    }
  }, [_vm._v("Register")])], 1)])])
},staticRenderFns: []}

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app__content about"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('section', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "section__wrapper about__two-col-layout"
  }, [_c('div', {
    staticClass: "section__content section__copy about__two-col-layout--item"
  }, [_c('h2', [_vm._v("Our back-end media compiler assembles a unique version every time 'Play' is pressed")]), _vm._v(" "), _c('p', [_vm._v("When a user visits our site and hits ‘Play’ our back-end media compiler assembles a unique composition built from the clips stored within the database.")]), _vm._v(" "), _c('p', [_vm._v("Each composite will be accompanied with a specially recorded version of God Save The Queen. Like the video, the audio track will be a unique edit built from a composite of audio loops.")]), _vm._v(" "), _c('p', [_vm._v("We have recorded hundreds of loops of varying tones (from soft to hard) and designed the back end system to select appropriate clips/sections of clips to match each unique audio construction.")]), _vm._v(" "), _c('p', [_vm._v("The lyrics to God Save The Queen are superimposed on top of every composite…")]), _vm._v(" "), _c('h2', [_vm._v("The unique composition will then be served")]), _vm._v(" "), _c('p', [_vm._v("Each view will be unique. The assembled video and the audio mix will be different every single time.")]), _vm._v(" "), _c('p', {
    staticClass: "about__register-link"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'view-register'
      }
    }
  }, [_vm._v("Back to registration")])], 1)]), _vm._v(" "), _vm._m(2)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "section__wrapper"
  }, [_c('div', {
    staticClass: "section__content section__copy"
  }, [_c('h2', [_vm._v("About")]), _vm._v(" "), _c('p', [_vm._v("The 2016 Brexit referendum left me dismayed and angered.")]), _vm._v(" "), _c('p', [_vm._v("The disinformation, the political opportunism, the frothing right-wing media and lack of a credible opposition led to a (let's not forget) non-binding decision to leave the EU.")]), _vm._v(" "), _c('p', [_vm._v("Since the referendum we have seen a hardening of the right (Tories and Press), an environment where dissent is branded treacherous and unpatriotic, obfuscation and confusion from the official opposition (Labour), deepening societal divisions and increasing fiscal inequality.")]), _vm._v(" "), _c('p', [_vm._v("Needless to say, all this is occurring alongside a divisive and regressive US presidency, an increasingly hostile, erratic Russia, environmental chaos and increasing instability around the world.")]), _vm._v(" "), _c('p', [_vm._v("With Britain, Take A Bow (a reworked title from the Daily Mail’s headline on the 25th June 2016) we’re asking filmmakers from across the UK to document this period and to participate in a collaborative and generative online A/V artwork.")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "section__wrapper about__two-col-layout"
  }, [_c('div', {
    staticClass: "section__content section__copy about__two-col-layout--item"
  }, [_c('h2', [_vm._v("It works like this")]), _vm._v(" "), _c('p', [_vm._v("You’ll upload your clips via the uploader on this website - we've designed a mobile interface to make it easy for you to capture and upload things on the fly.")]), _vm._v(" "), _c('p', [_vm._v("We want minimum restrictions: what you submit is up to you, however, your clips will be edited together at a fast pace so brevity is preferable - 10 seconds is a good benchmark.")]), _vm._v(" "), _c('p', [_vm._v("The intention is to capture vignettes of everyday British life as we approach the date we leave the EU (29th March 2019).")]), _vm._v(" "), _c('p', [_vm._v("You can upload as many clips as you like, there are no restrictions (the more we get, the better the experience will be).")]), _vm._v(" "), _c('p', [_vm._v("All audio will be stripped from the clips so please don’t make dialogue a feature.")]), _vm._v(" "), _c('p', [_vm._v("Format is unimportant; use your phone or 4K camera, in portrait or landscape format - it's up to you, but note that landscape will fill the screen while portrait will be ‘pillar-boxed' by black on both sides (best to avoid, if possible).")])]), _vm._v(" "), _c('div', {
    staticClass: "about__two-col-layout--item section__image"
  }, [_c('img', {
    staticClass: "about__image",
    attrs: {
      "src": __webpack_require__(195),
      "alt": "Upload process"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "about__two-col-layout--item section__image"
  }, [_c('img', {
    staticClass: "about__image",
    attrs: {
      "src": __webpack_require__(194),
      "alt": "Compilation process"
    }
  })])
}]}

/***/ }),
/* 231 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui-toggle"
  }, [(!_vm.toggle) ? _c('svg', {
    attrs: {
      "viewBox": "0 0 50 27",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('defs'), _vm._v(" "), _c('g', {
    attrs: {
      "id": "Plan-index",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "plans-page-analytics-and-filter-panel-open-lg",
      "transform": "translate(-1130.000000, -120.000000)"
    }
  }, [_c('g', {
    attrs: {
      "id": "Group-6",
      "transform": "translate(701.000000, 120.000000)"
    }
  }, [_c('g', {
    attrs: {
      "id": "Group-11",
      "transform": "translate(326.000000, 0.000000)"
    }
  }, [_c('g', {
    attrs: {
      "id": "toggle",
      "transform": "translate(128.000000, 13.500000) rotate(-180.000000) translate(-128.000000, -13.500000) translate(103.000000, 0.000000)"
    }
  }, [_c('g', {
    attrs: {
      "id": "Float"
    }
  }, [_c('rect', {
    attrs: {
      "id": "White-Background",
      "fill": "#C4E6EC",
      "x": "0",
      "y": "7",
      "width": "49.3548387",
      "height": "14",
      "rx": "7"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "ui-toggle__circle",
    attrs: {
      "id": "Knob",
      "cx": "36.5625",
      "cy": "13.8125",
      "r": "12.9375"
    }
  })])])])])])])]) : _vm._e(), _vm._v(" "), (_vm.toggle) ? _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('defs', [_c('circle', {
    attrs: {
      "id": "b",
      "cx": "29.25",
      "cy": "11.05",
      "r": "10.35"
    }
  }), _vm._v(" "), _c('filter', {
    attrs: {
      "x": "-45.9%",
      "y": "-16.9%",
      "width": "191.8%",
      "height": "201.4%",
      "filterUnits": "objectBoundingBox",
      "id": "toggleA"
    }
  }, [_c('feMorphology', {
    attrs: {
      "radius": ".5",
      "operator": "dilate",
      "in": "SourceAlpha",
      "result": "shadowSpreadOuter1"
    }
  }), _vm._v(" "), _c('feOffset', {
    attrs: {
      "dy": "3",
      "in": "shadowSpreadOuter1",
      "result": "shadowOffsetOuter1"
    }
  }), _vm._v(" "), _c('feGaussianBlur', {
    attrs: {
      "stdDeviation": "1.5",
      "in": "shadowOffsetOuter1",
      "result": "shadowBlurOuter1"
    }
  }), _vm._v(" "), _c('feComposite', {
    attrs: {
      "in": "shadowBlurOuter1",
      "in2": "SourceAlpha",
      "operator": "out",
      "result": "shadowBlurOuter1"
    }
  }), _vm._v(" "), _c('feColorMatrix', {
    attrs: {
      "values": "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0",
      "in": "shadowBlurOuter1",
      "result": "shadowMatrixOuter1"
    }
  }), _vm._v(" "), _c('feMorphology', {
    attrs: {
      "radius": ".5",
      "operator": "dilate",
      "in": "SourceAlpha",
      "result": "shadowSpreadOuter2"
    }
  }), _vm._v(" "), _c('feOffset', {
    attrs: {
      "dy": "2",
      "in": "shadowSpreadOuter2",
      "result": "shadowOffsetOuter2"
    }
  }), _vm._v(" "), _c('feGaussianBlur', {
    attrs: {
      "stdDeviation": "1",
      "in": "shadowOffsetOuter2",
      "result": "shadowBlurOuter2"
    }
  }), _vm._v(" "), _c('feComposite', {
    attrs: {
      "in": "shadowBlurOuter2",
      "in2": "SourceAlpha",
      "operator": "out",
      "result": "shadowBlurOuter2"
    }
  }), _vm._v(" "), _c('feColorMatrix', {
    attrs: {
      "values": "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0",
      "in": "shadowBlurOuter2",
      "result": "shadowMatrixOuter2"
    }
  }), _vm._v(" "), _c('feMorphology', {
    attrs: {
      "radius": ".5",
      "operator": "dilate",
      "in": "SourceAlpha",
      "result": "shadowSpreadOuter3"
    }
  }), _vm._v(" "), _c('feOffset', {
    attrs: {
      "dy": "3",
      "in": "shadowSpreadOuter3",
      "result": "shadowOffsetOuter3"
    }
  }), _vm._v(" "), _c('feGaussianBlur', {
    attrs: {
      "stdDeviation": ".5",
      "in": "shadowOffsetOuter3",
      "result": "shadowBlurOuter3"
    }
  }), _vm._v(" "), _c('feComposite', {
    attrs: {
      "in": "shadowBlurOuter3",
      "in2": "SourceAlpha",
      "operator": "out",
      "result": "shadowBlurOuter3"
    }
  }), _vm._v(" "), _c('feColorMatrix', {
    attrs: {
      "values": "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0510643116 0",
      "in": "shadowBlurOuter3",
      "result": "shadowMatrixOuter3"
    }
  }), _vm._v(" "), _c('feMerge', [_c('feMergeNode', {
    attrs: {
      "in": "shadowMatrixOuter1"
    }
  }), _vm._v(" "), _c('feMergeNode', {
    attrs: {
      "in": "shadowMatrixOuter2"
    }
  }), _vm._v(" "), _c('feMergeNode', {
    attrs: {
      "in": "shadowMatrixOuter3"
    }
  })], 1)], 1)]), _vm._v(" "), _c('g', {
    attrs: {
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('rect', {
    attrs: {
      "fill": "#C4E6EC",
      "y": "5.6",
      "width": "39.484",
      "height": "11.2",
      "rx": "5.6"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "ui-toggle__circle",
    attrs: {
      "stroke-opacity": ".1",
      "stroke": "#000",
      "stroke-width": ".5",
      "cx": "29.25",
      "cy": "11.05",
      "r": "10.6"
    }
  })])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 232 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app__content view-home"
  }, [_c('section', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "section__wrapper"
  }, [_c('div', {
    staticClass: "section__content section__copy"
  }, [_c('p', [_vm._v("Britain, Take A Bow is a generative artwork that sequences vignettes of British life, captured by a collaboration of filmmakers and artists across the UK, as we hurtle towards Brexit...")]), _vm._v(" "), _c('p', {
    staticClass: "mb-6"
  }, [_vm._v("Each 'play' is a unique experience - no two viewings will ever be the same")]), _vm._v(" "), _c('button', {
    staticClass: "button mr-2",
    on: {
      "click": _vm.goToVideo
    }
  }, [_vm._v("Play...")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'view-about'
      }
    }
  }, [_vm._v("About")])], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 233 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app__content section"
  }, [_c('div', {
    staticClass: "section__wrapper"
  }, [_c('div', {
    staticClass: "section__content"
  }, [(!_vm.registrationSuccess) ? _c('div', {
    staticClass: "section__copy"
  }, [_c('h2', [_vm._v("Registration")]), _vm._v(" "), _c('p', {}, [_vm._v("Thank you for participating. The videos you upload will be added to the video database and will be used to populate britaintakeabow.org")]), _vm._v(" "), _c('p', [_c('router-link', {
    attrs: {
      "to": {
        name: 'view-about'
      }
    }
  }, [_vm._v("Find out more about the project")])], 1), _vm._v(" "), _c('p', [_vm._v("Please complete the fields below:")])]) : _vm._e(), _vm._v(" "), (!_vm.registrationSuccess) ? _c('form', {
    staticClass: "form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submit()
      }
    }
  }, [_c('div', {
    staticClass: "form__group"
  }, [_c('label', {
    staticClass: "form__label",
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Name")]), _vm._v(" "), _c('div', {
    staticClass: "form__input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.auth.firstName),
      expression: "auth.firstName"
    }],
    staticClass: "form__input",
    class: {
      'form__input--error': _vm.$v.auth.firstName.$error
    },
    attrs: {
      "name": "name",
      "type": "text",
      "placeholder": "First name"
    },
    domProps: {
      "value": (_vm.auth.firstName)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.auth.firstName = $event.target.value
      }, function($event) {
        _vm.handleFieldInput('firstName')
      }]
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.auth.lastName),
      expression: "auth.lastName"
    }],
    staticClass: "form__input",
    class: {
      'form__input--error': _vm.$v.auth.lastName.$error
    },
    attrs: {
      "name": "name",
      "type": "text",
      "placeholder": "Last name"
    },
    domProps: {
      "value": (_vm.auth.lastName)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.auth.lastName = $event.target.value
      }, function($event) {
        _vm.handleFieldInput('lastName')
      }]
    }
  })]), _vm._v(" "), (_vm.$v.auth.firstName.$error || _vm.$v.auth.lastName.$error) ? _c('span', {
    staticClass: "form__help form__help--error"
  }, [_vm._v("\n            These fields are required.\n          ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form__group"
  }, [_c('label', {
    staticClass: "form__label",
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('div', {
    staticClass: "form__input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.auth.username),
      expression: "auth.username"
    }],
    staticClass: "form__input",
    class: {
      'form__input--error': _vm.$v.auth.username.$error
    },
    attrs: {
      "name": "email",
      "type": "email",
      "placeholder": "Your email address"
    },
    domProps: {
      "value": (_vm.auth.username)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.auth.username = $event.target.value
      }, function($event) {
        _vm.handleFieldInput('username')
      }]
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "form__help"
  }, [_vm._v("You'll need to confirm that this email address belongs to you")]), _vm._v(" "), (_vm.$v.auth.username.$error) ? _c('span', {
    staticClass: "form__help form__help--error"
  }, [_vm._v("\n            This field is required. Please use a valid email address.\n          ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form__group"
  }, [_c('label', {
    staticClass: "form__label",
    attrs: {
      "for": "password"
    }
  }, [_vm._v("Password")]), _vm._v(" "), _c('span', {
    staticClass: "form__help"
  }, [_vm._v("(required when you upload your videos)")]), _vm._v(" "), _c('div', {
    staticClass: "form__input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.auth.password),
      expression: "auth.password"
    }],
    staticClass: "form__input",
    class: {
      'form__input--error': _vm.$v.auth.password.$error
    },
    attrs: {
      "name": "password",
      "type": "password",
      "placeholder": "Password"
    },
    domProps: {
      "value": (_vm.auth.password)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.auth.password = $event.target.value
      }, function($event) {
        _vm.handleFieldInput('password')
      }]
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.auth.passwordConfirm),
      expression: "auth.passwordConfirm"
    }],
    staticClass: "form__input",
    class: {
      'form__input--error': _vm.$v.auth.passwordConfirm.$error
    },
    attrs: {
      "name": "passwordConfirm",
      "type": "password",
      "placeholder": "Confirm password"
    },
    domProps: {
      "value": (_vm.auth.passwordConfirm)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.auth.passwordConfirm = $event.target.value
      }, function($event) {
        _vm.handleFieldInput('passwordConfirm')
      }]
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "form__help"
  }, [_vm._v("Use 8 or more characters with a mix of letters, numbers & symbols")]), _vm._v(" "), (_vm.$v.auth.password.$error || _vm.$v.auth.passwordConfirm.$error) ? _c('span', {
    staticClass: "form__help form__help--error"
  }, [_vm._v("\n            Your password must be 8 or more characters. Password confirmation must match password.\n          ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form__group"
  }, [_c('label', {
    staticClass: "form__label",
    attrs: {
      "for": "links"
    }
  }, [_vm._v("Links")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "form__input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.auth.credit),
      expression: "auth.credit"
    }],
    staticClass: "form__input",
    attrs: {
      "name": "links",
      "type": "text",
      "placeholder": "Separate urls with commas"
    },
    domProps: {
      "value": (_vm.auth.credit)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.auth.credit = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "form__help"
  }, [_vm._v("We'll replace web links, twitter handles with clickable links")])]), _vm._v(" "), _c('div', {
    staticClass: "form__group"
  }, [_c('button', {
    staticClass: "button form__submit",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n              Register\n          ")]), _vm._v(" "), (_vm.authMessage) ? _c('p', {
    staticClass: "form__link mr-2"
  }, [_vm._v(_vm._s(_vm.authMessage))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.registrationSuccess) ? _c('div', [_c('h2', [_vm._v("Registration successful")]), _vm._v(" "), _c('p', [_vm._v("Thank you for registering, your account is now awaiting approval. Once approved, you will be notified by email and will be able to log in and upload videos.")])]) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "form__link",
    attrs: {
      "to": 'login'
    }
  }, [_vm._v("Login")])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section__copy"
  }, [_c('span', {
    staticClass: "form__help"
  }, [_vm._v("We'll credit you at the end of the video. Please add links to your website, Twitter, Facebook profile, Instagram etc below")])])
}]}

/***/ }),
/* 234 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "upload"
    }
  })
},staticRenderFns: []}

/***/ }),
/* 235 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app__content section"
  }, [_c('div', {
    staticClass: "section__wrapper"
  }, [_c('div', {
    staticClass: "section__content"
  }, [_c('h2', {}, [_vm._v("404 - Sorry, there's nothing here")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": '/'
    }
  }, [_vm._v("Go home")])], 1)])])
},staticRenderFns: []}

/***/ }),
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[84]);


// WEBPACK FOOTER //
// static/js/app.66d2527a37d44bfe6232.js